import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClipboardList, ExternalLink, Printer } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DispatchStatusBadge } from "@/components/lr-direct/DispatchStatusBadge";

interface Props {
  loadId: string;
  dispatch: any | null;
  dispatchStops: any[];
  /** Formatted dispatch sheet rendered in place of the old box layout. */
  sheet?: React.ReactNode;
}

export function DispatchTab({ loadId, dispatch, sheet }: Props) {
  const navigate = useNavigate();

  if (!dispatch) {
    return (
      <Card className="p-6 text-center">
        <ClipboardList className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
        <p className="text-sm font-medium mb-1">No dispatch packet yet</p>
        <p className="text-xs text-muted-foreground mb-3">Start preparing the dispatch packet — contacts, pickup numbers, special instructions.</p>
        <Button
          size="sm"
          className="gap-1.5 text-xs"
          style={{ backgroundColor: "hsl(var(--brand-teal))" }}
          onClick={() => navigate(`/lr-direct/dispatches/build/${loadId}`)}
        >
          <ClipboardList className="h-3.5 w-3.5" /> Prepare Dispatch
        </Button>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      <Card className="p-3">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <div className="flex items-center gap-2">
            <h3 className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider">Status</h3>
            <DispatchStatusBadge status={dispatch.status} />
          </div>
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              variant="outline"
              className="h-7 gap-1.5 text-xs"
              onClick={() => window.open(`/lr-direct/dispatch/${loadId}`, "_blank")}
            >
              <Printer className="h-3 w-3" /> Print
            </Button>
            <Button
              size="sm"
              className="h-7 gap-1.5 text-xs"
              style={{ backgroundColor: "hsl(var(--brand-teal))" }}
              onClick={() => navigate(`/lr-direct/dispatches/build/${loadId}`)}
            >
              <ExternalLink className="h-3 w-3" /> Edit Dispatch
            </Button>
          </div>
        </div>
      </Card>

      {sheet}
    </div>
  );
}
